import { client } from './contentfulClient';

export const getListingHighlightsImages = async (idArray: string[]): Promise<any> => {
  //convert listingHighlightsIds to string of comma separated values
  const listingHighlightsIdsString = idArray.join(',');
  const clientAssets = await client().getAssets({
    // get all Assets of supplied listingHighlightsIds
    'sys.id[in]': [listingHighlightsIdsString],
  });
  return clientAssets;
};
